
export default [
  {
    path: '/',
    meta: {
    },
    component: () => import('@/views/index')
  },
  {
    path: '/clerk/chat/roomInfo',
    meta: {
      title: '聊天',
      menuName: '聊天',
      menuPermission: 'chat'
    },
    component: () => import('@/views/2184/clerk/chat/roomInfo.vue')
  },
  {
    path: '/clerk/chat/roomList',
    meta: {
      title: '聊天消息',
      menuName: '聊天',
      menuPermission: 'chat'
    },
    component: () => import('@/views/2184/clerk/chat/roomList')
  },
  {
    path: '/clerk/chat/onlineList',
    meta: {
      title: '在线客户',
      menuName: '聊天',
      menuPermission: 'chat'
    },
    component: () => import('@/views/2184/clerk/chat/onlineList')
  },
]

